import { IconButton, Typography } from '@mui/material';
import { RootEntityType } from '@schooly/api';
import { useAuth } from '@schooly/components/authentication';
import { useUserNotifications } from '@schooly/context';
import { useFlag } from '@schooly/hooks/use-flag';
import { Counter, ThreadIcon } from '@schooly/style';
import { FC, useMemo } from 'react';

import { ThreadsSidebar } from './ThreadsSidebar';

export const ThreadsWidget: FC = () => {
  const [isOpen, open, close] = useFlag();
  const { currentUser } = useAuth();
  const { threadsUnread } = useUserNotifications();
  const userId = currentUser?.user_id;

  const unreadCount = useMemo(() => {
    const data = threadsUnread?.unread_threads?.[RootEntityType.MESSAGE];
    if (!data || !userId) return 0;

    return Object.keys(data).reduce(
      (acc, messageId) => acc + (data[messageId][0]?.root_entity.creator_id === userId ? 1 : 0),
      0,
    );
  }, [threadsUnread, userId]);

  return (
    <>
      <IconButton onClick={open} sx={{ position: 'relative' }}>
        {!!unreadCount && (
          <Counter
            sx={{
              position: 'absolute',
              backgroundColor: 'success.main',
              right: -7,
              top: -7,
              width: 16,
              height: 16,
            }}
          >
            <Typography sx={{ verticalAlign: 'top' }} variant="body3">
              {unreadCount}
            </Typography>
          </Counter>
        )}
        <ThreadIcon />
      </IconButton>

      <ThreadsSidebar open={isOpen} onClose={close} />
    </>
  );
};
